import React from "react";
import "./Projects.css";
import { useNavigate } from "react-router-dom";
import CodeRain from "../components/CodeRain";
import { motion } from "framer-motion";

const Projects = () => {
  const navigate = useNavigate();

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.15, duration: 0.55, type: "spring", stiffness: 80 },
    }),
  };

  const projects = [
    {
      title: "Studiedjungeln",
      emoji: "📚",
      description: "Full-stack learning platform with JWT auth, a randomised exercise engine, and a gamified progress system — built end-to-end.",
      tags: ["React", "Spring Boot", "MySQL", "JWT"],
      path: "/studiedjungeln",
    },
    {
      title: "Mobile Apps",
      emoji: "📱",
      description: "Four React Native apps published to Google Play, delivered for real clients in higher education, healthcare, defence, and environmental sectors.",
      tags: ["React Native", "Expo", "Firebase", "Google Play"],
      path: "/mobilappar",
    },
    {
      title: "BokBubblan",
      emoji: "📦",
      description: "Full-stack e-commerce platform — REST API, cart management, and full checkout flow — built with Java, Spring Boot, and vanilla JavaScript.",
      tags: ["Java", "Spring Boot", "JavaScript", "REST API"],
      path: "/bokbubblan",
    },
  ];

  return (
    <div id="projects" className="projects-container">
      <CodeRain />

      <motion.div
        className="projects-content"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <h1 className="projects-heading">My Projects</h1>
        <p className="projects-subheading">
          A selection of full-stack applications built for real clients and personal development.
        </p>

        <div className="project-grid">
          {projects.map((project, i) => (
            <motion.div
              key={project.title}
              className="project-card"
              onClick={() => navigate(project.path)}
              custom={i}
              initial="hidden"
              animate="visible"
              variants={cardVariants}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <div className="project-card-inner">
                <h2>{project.emoji} {project.title}</h2>
                <p>{project.description}</p>
                <div className="project-tags">
                  {project.tags.map((tag) => (
                    <span key={tag} className="project-tag">{tag}</span>
                  ))}
                </div>
                <span className="project-card-arrow">View case study →</span>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Projects;
